import React from 'react';

const TranchesList = ({ tranchesPaiement, tarifs, calculerRepartitionPaiement, montantVerse }) => {
  if (!tranchesPaiement || tranchesPaiement.length === 0) {
    return (
      <div className="p-4 text-center text-gray-500">
        Aucune modalité de paiement configurée
      </div>
    );
  }

  const repartition = calculerRepartitionPaiement(montantVerse);

  return (
    <div className="space-y-4">
      <h4 className="font-medium text-gray-900">Répartition par échéances</h4>
      {tranchesPaiement.map(tranche => {
        const montantTranche = (tarifs?.prix * tranche.pourcentage) / 100;
        const details = repartition[tranche.id];
        
        if (!details) return null;

        return (
          <div key={tranche.id} className={`p-4 rounded-lg border ${
            details.estPayeComplet ? 'bg-green-50 border-green-200' :
            details.estPayePartiel ? 'bg-blue-50 border-blue-200' :
            'bg-gray-50 border-gray-200'
          }`}>
            <div className="flex justify-between items-start mb-2">
              <div>
                <h5 className="font-medium text-gray-900">
                  {tranche.libelle}
                </h5>
                <p className="text-sm text-gray-600">
                  {tranche.pourcentage}% des frais de scolarité
                </p>
                <p className="text-xs text-gray-500">
                  Échéance: {new Date(tranche.date).toLocaleDateString('fr-FR')}
                </p>
              </div>
              <div className="text-right">
                <p className="font-medium text-gray-900">
                  {montantTranche.toLocaleString()} FCFA
                </p>
                <p className={`text-sm ${
                  details.estPayeComplet ? 'text-green-600' :
                  details.estPayePartiel ? 'text-blue-600' :
                  'text-gray-600'
                }`}>
                  {details.estPayeComplet ? 'Payé' :
                   details.estPayePartiel ? 'Partiellement payé' :
                   'À venir'}
                </p>
              </div>
            </div>
            
            {(details.estPayeComplet || details.estPayePartiel) && (
              <div className="mt-2">
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div
                    className={`h-2 rounded-full ${
                      details.estPayeComplet ? 'bg-green-500' : 'bg-blue-500'
                    }`}
                    style={{ width: `${(details.montantPaye / montantTranche) * 100}%` }}
                  />
                </div>
                <div className="flex justify-between text-xs mt-1">
                  <span className="text-green-600">
                    Payé: {details.montantPaye.toLocaleString()} FCFA
                  </span>
                  {!details.estPayeComplet && (
                    <span className="text-red-600">
                      Reste: {details.montantRestant.toLocaleString()} FCFA
                    </span>
                  )}
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default TranchesList; 